<template>
    <div class="container-fluid">
        <h1>{{$t('menuItemPrint')}}</h1>
        <printing-manager class="pt-4"/>
    </div>
</template>

<script>
    import PrintingManager from '../../components/printing/dashboard/index.vue';

    export default { components: { 'printing-manager': PrintingManager } };
</script>
